// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-home-A":"A_power-ocean-home-A__DDxxa"};